var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{staticClass:"st0",attrs:{"d":"M78.2,40L305,424.3L520.9,40.8l78.7,44.4L345.3,537c-7.9,14.1-22.7,22.8-38.9,23c-0.2,0-0.3,0-0.5,0\n\tc-16,0-30.8-8.4-38.9-22.2L0.4,86L78.2,40z"}})}
var staticRenderFns = []

export { render, staticRenderFns }